import { Serializable } from '@/models/core/serializable';
import { GEnum } from '@/constants/enum.defination';
import i18n from '@/i18n';

export class ReportStatus implements Serializable<ReportStatus> {
  giftCourseID: number;
  status: GEnum.ReportStatus;
  completedAt: Date;

  deserialize(input: any): ReportStatus {
    this.giftCourseID = input.giftCourseID;
    this.status = input.status;
    if (input.completedAt !== null) {
      this.completedAt = input.completedAt;
    }

    return this;
  }

  get tooltipContentText(): string {
    switch (this.status) {
      case GEnum.ReportStatus.NoCompleted:
        return i18n.t('NOTICE_CANNOT_CREATE_REPORT').toString();
      case GEnum.ReportStatus.Requesting:
        return i18n.t('NOTICE_PLEASE_WAIT').toString();
      case GEnum.ReportStatus.Creating:
        return i18n.t('NOTICE_PLEASE_WAIT').toString();
    }
  }

  get reportStatusText(): string {
    switch (this.status) {
      case GEnum.ReportStatus.NoRequest:
        return i18n.t('UNGENERATED').toString();
      case GEnum.ReportStatus.Requesting:
        return i18n.t('REQUESTING').toString();
      case GEnum.ReportStatus.Creating:
        return i18n.t('FEEDBACK_REPORT_GENERATING').toString();
      case GEnum.ReportStatus.Completed:
        return i18n.t('FEEDBACK_REPORT_GENERATED').toString();
      case GEnum.ReportStatus.CreateError:
        return i18n.t('FEEDBACK_REPORT_FAILED').toString();
    }
  }

  get reportZipStatusColor(): string {
    switch (this.status) {
      case GEnum.ReportStatus.NoRequest:
        return 'grey';
      case GEnum.ReportStatus.Requesting:
        return 'warning';
      case GEnum.ReportStatus.Creating:
        return 'primary';
      case GEnum.ReportStatus.Completed:
        return 'success';
      case GEnum.ReportStatus.CreateError:
        return 'error';
      default:
        return 'grey';
    }
  }

  get isReportStatusNoCompleted(): boolean {
    return this.status === GEnum.ReportStatus.NoCompleted;
  }
  get isReportStatusNoRequest(): boolean {
    return this.status === GEnum.ReportStatus.NoRequest;
  }
  get isReportStatusRequesting(): boolean {
    return this.status === GEnum.ReportStatus.Requesting;
  }
  get isReportStatusCreating(): boolean {
    return this.status === GEnum.ReportStatus.Creating;
  }
  get isReportStatusCompleted(): boolean {
    return this.status === GEnum.ReportStatus.Completed;
  }
  get isReportStatusCreateError(): boolean {
    return this.status === GEnum.ReportStatus.CreateError;
  }
}
